<template>
  <div class="yu-step"
       :class="[{simple: rootSteps.simple},{center:rootSteps.center}]">
    <!--icon && line-->
    <div class="head">
      <div class="icon status"
           v-if="!icon"
           :class="[{'success-icon':iconSuccess},{conduct:conduct},status]">
        <i   class="iconfont"  :class="{'icon-check':iconSuccess,}"
             v-if="iconSuccess"></i>
        <span v-else class="step"></span>
      </div>
      <div class="have-icon"
           :class="[{'have-icon-success':iconSuccess,},{'have-icon-conduct':conduct},`have-${status}`]"
           v-else>
        <i class="iconfont" :class="[icon]"></i>
      </div>
      <div class="line"
           v-if="lastLine"
           :class="{'line-success':lineSuccess}">
      </div>
    </div>
    <!--title   &&  description-->
    <div class="main">
      <div class="main-title"
           :class="[{'conduct-text':conduct,'success-text':iconSuccess},status]">{{title}}</div>
      <div class="description" v-if="description">{{description}}</div>
    </div>
    <div class="arrow" v-if="rootSteps.simple">
      <i class="iconfont icon-angle-right"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'YuStep',
  data() {
    return {
      formerly: true,
      lastLine: true,
      iconSuccess: false,
      lineSuccess: false,
      conduct: false,
    }
  },
  inject: ['rootSteps'],
  props: {
    title: String,
    description: String,
    icon: String,
    status: String,
  },
  mounted() {
    this.$el.nextElementSibling ? this.lastLine = true : this.lastLine = false;
    this.conduct = !this.$el.previousElementSibling;
    if (this.rootSteps.simple) {
      this.lastLine = false;
    }
  },
}
</script>

<style scoped lang="scss" type="text/scss">
  @import "../assets/css/varible";
  @import "../assets/css/function";
  .yu-step {
    display: inline-block;
    width: calc(100% / 3);
    overflow: hidden;
    .head {
      margin-bottom: 20px;
      .icon{
        display: inline-block;
        padding: 5px;
        width: 30px;
        height: 30px;
        box-sizing: border-box;
        background-color: #fff;
        color: $light-text;
        border-radius: 50%;
        border: 2px solid $light-text;
      }
      .step{
        margin-left: 3px;
      }
      .have-icon{
       i{
         font-size: 30px;
       }
      }
      .success{
        font-weight: 800;
        color: $success;
        i{
          color: $success;
        }
      }
      .error{
        i{
          color: $danger;
        }
      }
      .warning{
        i{
          color: $warning;
        }
      }
      .finish{
        i{
          color: $primary;
        }
      }
      .have-success{
        i{
          color: $success;
        }
      }
      .have-error{
        i{
          color: $danger;
        }
      }
      .have-warning{
        i{
          color: $warning;
        }
      }
      .have-finish{
        i{
          color: $primary;
        }
      }
      .have-icon-conduct{
        color: #000;
      }
      .conduct {
        color: #000;
        border: 2px solid #000;
      }
        .line {
          height: 2px;
          min-width: 100px;
          background-color: $light-text;
          margin-left: 30px;
          margin-top: -15px;
          vertical-align: middle;
        }
        .success-icon {
          color: $success;
          border: 2px solid $success;
        }
      .have-icon-success{
        color: $success;
      }
        .line-success {
          background-color: $success;
        }
      }
      &:last-child {
        .head {
          margin-bottom: 5px;
        }
      }
    .main{
      .conduct-text{
        color: #000;
        font-weight: 800;
      }
      .description{
        padding: 5px 10px 5px 0;
      }
      .success-text{
        color: $success;
        font-weight: 600;
      }
      .success{
        font-weight: 800;
        color: $success;
        i{
          color: $success;
        }
      }
      .error{
        color: $danger;
        i{
          color: $danger;
        }
      }
      .wait{
        i{
          color: $warning;
        }
      }
      .finish{
        i{
          color: $primary;
        }
      }
      .have-success{
        i{
          color: $success;
        }
      }
      .have-error{
        i{
          color: $danger;
        }
      }
      .have-warning{
        i{
          color: $warning;
        }
      }
      .have-finish{
        i{
          color: $primary;
        }
      }
    }
    }
  /*简洁风格*/
  .yu-step.simple{
    background-color: lighten($info, 35);
    text-align: center;
    padding: 10px 0;
    .head{
      margin-bottom: 5px;
      display: inline-block;
      .have-icon{
        .iconfont{
          font-size: $huge;
        }
      }
    }
    .main{
      display: inline-block;
    }
    .arrow{
      float: right;
      i{
        font-size: $huge;
        color: $light-text;
      }
    }
    &:last-child .arrow{
      display: none;
    }
  }
  /*居中*/
  .yu-step.center {
    text-align: center;
    position: relative;
    overflow: visible;
    .head {
      margin-bottom: 20px;
      .line {
        position: absolute;
        z-index: -2;
        left: 40%;
        right: -50%;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// node_modules/_yu.ui@1.2.0@yu.ui/src/components/step.vue